import Dialog from 'global/guides/Dialog'

interface IProps {
    open: boolean
    onSubmit: (values: any) => any
    onClose: () => void
}

export default function AvisoAfastamento({ open, onClose, onSubmit }: IProps) {
    return (
        <Dialog.Root
            open={open}
            height="auto"
            width="40rem"
            onClose={onClose}
            onSubmit={onSubmit}
        >
            <Dialog.Title>
                Existem registros dentro do período selecionado
            </Dialog.Title>
            <Dialog.Content>
                Caso continue, o afastamento poderá ser modificado para não
                ocupar o mesmo espaço de outros registros.
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton>
                    Continuar
                </Dialog.Actions.PrimaryButton>
            </Dialog.Actions>
        </Dialog.Root>
    )
}
